import { RegularButton, Typography } from 'fronton-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { Styles } from './form-submit-thanks.style';

export type FormSubmitThanksSectionProps = {
  productMainPhoto: string;
};

export const FormSubmitThanksSection: React.FC<FormSubmitThanksSectionProps> = ({ productMainPhoto }) => {
  const { t } = useTranslation();
  return (
    <section className={Styles.formSubmitThanks}>
      <ImagePlaceholder
        className={Styles.thanksMainPhoto}
        src={productMainPhoto}
        loading="lazy"
        alt=""
        fallbackWidth={80}
        fallbackHeight={80}
        fallbackAlt={t('ui.image.alt')}
      />
      <Typography className={Styles.thanksH1} variant="h1">
        {t('reviews.form.submit.part1')}
      </Typography>
      <Typography className={Styles.thanksMessage} variant="m" size="body_short">
        {t('reviews.form.submit.part2')}
      </Typography>

      <RegularButton href="/" className={Styles.thanksAction} size="l" rounded variant="primary">
        {t('reviews.form.submit.part3')}
      </RegularButton>
    </section>
  );
};
